/* 203 (Toni 7.10.2026 «2. B»): puuttuva VT ei estä linjatarkastusta, mutta linja merkitään, jotta tarkastaja tekee VT:n
   linjatarkastuksen yhteydessä. Yksi komponentti nipun listoille ja linjatarkastusnäkymälle. «ilman tulosta» = VT-rivi on
   (masterissa usein päivä tai nimikirjaimet), mutta tulos ei ole hyväksytty — eri asia kuin kokonaan puuttuva VT. */
import { t } from "./kieli";

export default function VtMerkki({ n, ilmanTulosta }: { n?: number | null; ilmanTulosta?: number | null }) {
  if (!n) return null;
  return (
    <span className="huom" data-vt-puuttuu={n} style={{ display: "block", margin: "2px 0 0" }}>
      {t(n === 1 ? "vtm.puuttuu_1" : "vtm.puuttuu_n", { n })}
      {ilmanTulosta ? <span className="dim"> · {t("vtm.ilman_tulosta", { n: ilmanTulosta })}</span> : null}
    </span>
  );
}
